// src/components/AdminBlog.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE, UPLOADS_BASE } from '../apiConfig';
import '../css/AdminBlog.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'summernote/dist/summernote-bs4.css';
import 'summernote/dist/summernote-bs4.js';
import $ from 'jquery';

function AdminBlog({ embedded = false, onLogout }) {
  const [posts, setPosts] = useState([]);
  const [form, setForm] = useState({ 
    title: '', 
    slug: '', 
    meta_title: '', 
    meta_description: '', 
    keywords: '', 
    content: '', 
    author: '',
    post_type: 'blog' // <-- FIXED: set default value to 'blog'
  });
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState('');
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const [filterType, setFilterType] = useState('all'); // <-- NEW: filter by post type

  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const correctPassword = 'admin123';

  useEffect(() => {
    if (embedded) {
      setIsAuthenticated(true);
      return;
    }
    const auth = localStorage.getItem('admin-blog-auth');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, [embedded]);

  const fetchPosts = () => {
    setLoading(true);
    axios.get(`${API_BASE}/blog`)
      .then(res => setPosts(res.data))
      .catch(() => setError('Error fetching posts'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchPosts();

      if ($('#summernote').next().hasClass('note-editor')) {
        $('#summernote').summernote('destroy');
      }

      $('#summernote').summernote({
        placeholder: 'Enter blog content...',
        height: 200,
        dialogsInBody: true,
        callbacks: {
          onChange: function (contents) {
            setForm(prev => ({ ...prev, content: contents }));
          }
        }
      });
    }
  }, [isAuthenticated]);

  // Add admin-page class to body when component mounts
  useEffect(() => {
    document.body.classList.add('admin-page');
    
    // Cleanup: remove class when component unmounts
    return () => {
      document.body.classList.remove('admin-page');
    };
  }, []);

  // Debug: Monitor form.post_type changes
  useEffect(() => {
    console.log('form.post_type changed to:', form.post_type);
  }, [form.post_type]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Use FormData for file upload
    const formData = new FormData();
    
    // 🔍 Validation: Ensure post_type is not empty
    if (!form.post_type || form.post_type.trim() === '') {
      setError('Please select a post type (Blog or News)');
      setLoading(false);
      return;
    }
    
    console.log('=== SUBMIT DEBUG ===');
    console.log('Form data before submit:', form);
    console.log('post_type being sent:', form.post_type);
    console.log('post_type type:', typeof form.post_type);
    console.log('===================');
    
    formData.append('title', form.title);
    formData.append('slug', form.slug);
    formData.append('meta_title', form.meta_title);
    formData.append('meta_description', form.meta_description);
    formData.append('keywords', form.keywords);
    formData.append('content', form.content);
    formData.append('author', form.author);
    formData.append('post_type', form.post_type); // <-- NEW: append post type
    
    // Debug: Log all FormData entries
    console.log('=== FORMDATA DEBUG ===');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }
    console.log('=====================');
    if (image) {
      formData.append('image', image);
    }

    try {
      if (editId) {
        // Some servers/frameworks have issues with multipart PUT.
        // Use method override to ensure Laravel handles file + PUT correctly.
        formData.append('_method', 'PUT');
      
        // 🔍 Debug قبل الإرسال
        console.log('=== Debug Info ===');
        console.log('API URL:', `${API_BASE}/blog/${editId}`);
        console.log('Request Method: PUT');
        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value);
        }
      
        await axios.post(`${API_BASE}/blog/${editId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        // 🔍 Debug قبل الإرسال
        console.log('=== Debug Info ===');
        console.log('API URL:', `${API_BASE}/blog`);
        console.log('Request Method: POST');
        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value);
        }
      
        await axios.post(`${API_BASE}/blog`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }
      

      setForm({
        title: '', slug: '', meta_title: '', meta_description: '',
        keywords: '', content: '', author: '', post_type: form.post_type // <-- Keep the selected post type
      });
      setEditId(null);
      setImage(null);
      setImagePreview('');
      $('#summernote').summernote('code', '');
      fetchPosts();

    } catch (err) {
      console.error(err);
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else if (err.message) {
        setError(`Network or Server error: ${err.message}`);
      } else {
        setError('Unexpected error occurred.');
      }
    } finally {
      setLoading(false);
    }
  };


  const handleDelete = async (id) => {
    if (window.confirm('Delete this post?')) {
      try {
        await axios.delete(`${API_BASE}/blog/${id}`);
        fetchPosts();
      } catch (err) {
        alert('Failed to delete the post.');
        console.error(err);
      }
    }
  };

  const handleEdit = (post) => {
    setForm({
      title: post.title || '',
      slug: post.slug || '',
      meta_title: post.meta_title || '',
      meta_description: post.meta_description || '',
      keywords: post.keywords || '',
      content: post.content || '',
      author: post.author || '',
      post_type: post.post_type // <-- NEW: set post type from post
    });
    setEditId(post.id);
    setImage(null);
    setImagePreview(post.image ? `${UPLOADS_BASE}/${post.image}` : '');
    $('#summernote').summernote('code', post.content);
  };

  const handleLogout = () => {
    if (embedded && typeof onLogout === 'function') {
      onLogout();
      return;
    }
    localStorage.removeItem('admin-blog-auth');
    setIsAuthenticated(false);
    setPassword('');
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-blog-container py-5">
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="card admin-form-card shadow">
              <div className="card-header">
                <h4 className="mb-0 header-title">🔒 Admin Access</h4>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control custom-input"
                    placeholder="Enter admin password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="small text-muted mb-3">Use your admin password to access the Blog Manager.</div>
                <button className="btn custom-btn btn-create w-100" onClick={() => {
                  if (password === correctPassword) {
                    localStorage.setItem('admin-blog-auth', 'true');
                    setIsAuthenticated(true);
                  } else {
                    alert('Incorrect password');
                  }
                }}>Enter</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-blog-container">
      <div className="row justify-content-center">
        <div className="col-12 col-xl-10">
          {/* Toolbar moved to bottom */}

          {/* Form + Preview */}
          <div className="card admin-form-card mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3 className="header-title mb-0">{editId ? 'Edit Post' : 'Create New Post'}</h3>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                {error && <div className="alert alert-danger">{error}</div>}
                {loading && <div className="alert alert-info py-2 mb-3">Processing... Please wait.</div>}

                <div className="row g-3">
                  <div className="col-12 col-lg-7">
                    <div className="form-group mb-3">
                      <label className="form-label">Title</label>
                      <input type="text" className="form-control custom-input" value={form.title} onChange={e=>setForm({ ...form, title: e.target.value })} required />
                    </div>
                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <div className="form-group mb-3">
                          <label className="form-label">Slug</label>
                          <input type="text" className="form-control custom-input" value={form.slug} onChange={e=>setForm({ ...form, slug: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group mb-3">
                          <label className="form-label">
                            Post Type 
                            {form.post_type && (
                              <span className="ms-2 badge bg-success" style={{fontSize: '0.7rem'}}>
                                ✓ {form.post_type === 'blog' ? 'Blog' : 'News'}
                              </span>
                            )}
                          </label>
                          <select 
                            className={`form-select custom-input ${!form.post_type ? 'border-danger' : 'border-success'}`}
                            value={form.post_type} 
                            onChange={e => {
                              const newPostType = e.target.value;
                              console.log('Selected post_type:', newPostType);
                              if (newPostType && newPostType.trim() !== '') {
                                setForm(prevForm => {
                                  const updatedForm = { ...prevForm, post_type: newPostType };
                                  console.log('Updated form with post_type:', updatedForm.post_type);
                                  return updatedForm;
                                });
                              }
                            }}
                            required
                          >
                            <option value="">-- Select Post Type --</option>
                            <option value="blog">Blog Post</option>
                            <option value="news">News Article</option>
                          </select>
                          {!form.post_type && (
                            <div className="text-danger small mt-1">Please select a post type</div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <div className="form-group mb-3">
                          <label className="form-label">Author</label>
                          <input type="text" className="form-control custom-input" value={form.author} onChange={e=>setForm({ ...form, author: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group mb-3">
                          <label className="form-label">Keywords</label>
                          <input type="text" className="form-control custom-input" value={form.keywords} onChange={e=>setForm({ ...form, keywords: e.target.value })} />
                        </div>
                      </div>
                    </div>
                    <div className="form-group mb-3">
                      <label className="form-label">Meta Title</label>
                      <input type="text" className="form-control custom-input" value={form.meta_title} onChange={e=>setForm({ ...form, meta_title: e.target.value })} />
                    </div>
                    <div className="form-group mb-3">
                      <label className="form-label">Meta Description</label>
                      <textarea className="form-control custom-textarea" rows={2} value={form.meta_description} onChange={e=>setForm({ ...form, meta_description: e.target.value })} />
                    </div>
                    <div className="form-group mb-3">
                      <label className="form-label">Content</label>
                      <div id="summernote" />
                    </div>
                    <button type="submit" className={`btn custom-btn ${editId ? 'btn-edit' : 'btn-create'}`} disabled={loading}>
                      {editId ? 'Update Post' : 'Add New Post'}
                    </button>
                  </div>
                  <div className="col-12 col-lg-5">
                    <div className="image-input-container">
                      <label className="form-label">📸 Image</label>
                      <input type="file" className="form-control custom-input" accept="image/*" onChange={e => { setImage(e.target.files[0]); setImagePreview(e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : ''); }} />
                    </div>
                    <div className="image-preview-container">
                      <div className="mb-3 fw-bold text-center" style={{color: '#2c3e50', fontSize: '1.1rem'}}>🎯 Live Preview</div>
                      <div className="mb-3 text-center">
                        <span className={`badge ${form.post_type === 'blog' ? 'bg-primary' : 'bg-success'}`} style={{fontSize: '0.9rem', padding: '0.5rem 1rem'}}>
                          {form.post_type === 'blog' ? '📝 Blog Post' : '📰 News Article'}
                        </span>
                      </div>
                      {imagePreview ? (
                        <img src={imagePreview} alt="Preview" style={{width:'100%',height:220,objectFit:'cover',borderRadius:12,boxShadow: '0 4px 15px rgba(0,0,0,0.1)'}} />
                      ) : (
                        <div className="text-center text-muted small p-4" style={{border: '2px dashed rgba(255,102,0,0.3)', borderRadius: 8, background: 'rgba(255,102,0,0.05)'}}>
                          📁 No image selected
                        </div>
                      )}
                      <hr style={{borderColor: 'rgba(255,102,0,0.2)'}}/>
                      <div className="mt-3">
                        <div className="fw-bold text-center" style={{color:'#2c3e50', fontSize: '1.1rem'}}>{form.title || 'Post title'}</div>
                        <div className="text-muted small text-center mt-2">{form.meta_description || 'Meta description preview...'}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Content Management Toolbar */}
          <div className="admin-toolbar d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 mb-4 p-4" style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)',
            borderRadius: '16px',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255,255,255,0.3)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
          }}>
            <h2 className="mb-0" style={{color:'#2c3e50', fontWeight:800, fontSize: '2.2rem', textShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
              🎯 Content Management
            </h2>
            <div className="d-flex gap-3">
              <select 
                className="form-select custom-input" 
                value={filterType} 
                onChange={(e) => setFilterType(e.target.value)}
                style={{maxWidth: 140, fontWeight: 600}}
              >
                <option value="all">📋 All Types</option>
                <option value="blog">📝 Blog Only</option>
                <option value="news">📰 News Only</option>
              </select>
              <input
                type="search"
                className="form-control custom-input"
                placeholder="🔍 Search posts by title..."
                value={searchTerm}
                onChange={(e)=>setSearchTerm(e.target.value)}
                style={{minWidth: '250px'}}
              />
              <button className="btn custom-btn btn-edit" onClick={handleLogout} style={{background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)', border: 'none'}}>
                🚪 Logout
              </button>
            </div>
          </div>

          {/* Posts list */}
          <div className="card blog-list-card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3 className="header-title mb-0">All Posts</h3>
              <span className="badge bg-light text-dark">
                {posts.filter(p => filterType === 'all' || p.post_type === filterType).length} items
              </span>
            </div>
            <div className="card-body">
              {loading && posts.length === 0 && <div className="no-blogs">Loading posts...</div>}
              {!loading && posts.length === 0 && <div className="no-blogs">No posts yet.</div>}
              <div className="row g-3">
                {posts
                  .filter(p => (filterType === 'all' || p.post_type === filterType) && (searchTerm ? (p.title || '').toLowerCase().includes(searchTerm.toLowerCase()) : true))
                  .map(post => (
                  <div key={post.id} className="col-12">
                    <div className="blog-card p-2 p-md-3 d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center gap-3">
                        {post.image && (
                          <img src={`${UPLOADS_BASE}/${post.image}`} alt="Blog" style={{ width: 96, height: 64, objectFit: 'cover', borderRadius: 8 }} />
                        )}
                        <div>
                          <div className="d-flex align-items-center gap-2 mb-1">
                            <span className={`badge ${post.post_type === 'blog' ? 'bg-primary' : 'bg-success'}`}>
                              {post.post_type === 'blog' ? 'Blog' : 'News'}
                            </span>
                            <div className="blog-title" dangerouslySetInnerHTML={{ __html: post.title }} />
                          </div>
                          <div className="text-muted small">{post.author || 'Unknown'} • {post.created_at || ''}</div>
                        </div>
                      </div>
                      <div className="d-flex gap-2">
                        <button className="btn action-btn edit-btn" onClick={() => handleEdit(post)}>Edit</button>
                        <button className="btn action-btn delete-btn" onClick={() => handleDelete(post.id)}>Delete</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default AdminBlog;
